import React, { useState, useMemo } from 'react';
import styled from 'styled-components';
import Cookies from 'js-cookie';

const Container = styled.div`
  padding: 0 20px 80px 20px;
  background-color: #fff;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: 500px;
  overflow: hidden;
`;

const Header = styled.h3`
  margin-bottom: 20px;
  flex-shrink: 0;
`;

const QuantityContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-shrink: 0;
`;

const QuantityButton = styled.button`
  width: 30px;
  height: 30px;
  margin: 0 10px;
  font-size: 18px;
  cursor: pointer;
  border: none;
  background-color: #f0f0f0;
  border-radius: 5px;
`;

const DateList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  padding-right: 10px;
  padding-bottom: 80px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
`;

const DateLabel = styled.span`
  margin-left: 10px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-top: 1px solid #ddd;
  background: white;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
`;

const PriceDisplay = styled.div`
  font-size: 18px;
  font-weight: bold;
`;

const ConfirmButton = styled.button`
  background-color: orange;
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  pointer-events: auto;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;

  &:active {
    background-color: darkorange;
  }
`;

const Notice = styled.div`
  color: red;
  margin-top: 10px;
  font-size: 14px;
  flex-shrink: 0;
`;

const FullBadge = styled.span`
  color: red;
  font-weight: bold;
  font-size: 12px;
  margin-left: 8px;
`;

const AvailabilityBadge = styled.span`
  color: #666;
  font-size: 12px;
  margin-left: 8px;
`;

const SectionLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  margin-top: 4px;
`;

const FixedDateItem = styled.li`
  margin-bottom: 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #555;
`;

const FixedIcon = styled.span`
  margin-right: 10px;
  font-size: 16px;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #eee;
  margin: 12px 0;
`;

const DayGroup = styled.li`
  list-style: none;
  margin-bottom: 8px;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
`;

const DayHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 14px;
  background-color: ${(props) => (props.$open ? '#fafafa' : '#fff')};
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
`;

const DayHeaderLeft = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DaySummary = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: #888;
`;

const SelectedPill = styled.span`
  background-color: orange;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
`;

const Chevron = styled.span`
  font-size: 12px;
  color: #888;
  transition: transform 0.15s ease;
  transform: rotate(${(props) => (props.$open ? '180deg' : '0deg')});
`;

const SummaryWrap = styled.div`
  flex-shrink: 0;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
`;

const SummaryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const SummaryTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

const SummaryProgress = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => (props.$complete ? '#1a8f3c' : 'orange')};
`;

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #fff4e5;
  border: 1px solid #ffcf99;
  color: #b35c00;
  border-radius: 16px;
  padding: 4px 6px 4px 12px;
  font-size: 13px;
  font-weight: 500;
`;

const ChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 50%;
  background-color: #ffcf99;
  color: #7a3f00;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
`;

const EmptySummary = styled.span`
  font-size: 13px;
  color: #999;
`;

const TimeslotList = styled.div`
  padding: 4px 14px 10px 14px;
`;

const TimeslotItem = styled.label`
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 16px;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$full ? 0.5 : 1)};
`;

const QuantityDateSelector = ({ classDates, fixedClassDates = [], onConfirm, baseFee, maxQuantity, capacityMode, pricingMode = 'per_class', selectionMode = 'exact' }) => {
  const isExact = selectionMode === 'exact';
  const [quantity, setQuantity] = useState(isExact ? maxQuantity : 1);
  const [selectedDates, setSelectedDates] = useState([]);

  // Sort classDates by date
  const sortedClassDates = useMemo(
    () => [...classDates].sort((a, b) => new Date(a.date) - new Date(b.date)),
    [classDates]
  );

  // Group selectable classes by calendar day so users pick a day first,
  // then a timeslot within that day (handles same-day, different-time classes).
  const dayGroups = useMemo(() => {
    const groups = new Map();
    sortedClassDates.forEach((cd) => {
      const d = new Date(cd.date);
      const key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
      if (!groups.has(key)) {
        groups.set(key, { key, date: d, items: [] });
      }
      groups.get(key).items.push(cd);
    });
    return Array.from(groups.values());
  }, [sortedClassDates]);

  // Expand the day automatically when it's the only one available.
  const [expandedDays, setExpandedDays] = useState(() =>
    dayGroups.length === 1 ? { [dayGroups[0].key]: true } : {}
  );

  const toggleDay = (key) => {
    setExpandedDays((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleQuantityChange = (change) => {
    setQuantity((prev) => {
      const newQuantity = Math.max(1, Math.min(prev + change, maxQuantity));
      if (selectedDates.length > newQuantity) {
        setSelectedDates(selectedDates.slice(0, newQuantity));
      }
      return newQuantity;
    });
  };

  const handleDateChange = (date) => {
    const isSelecting = !selectedDates.includes(date);
    // When selecting a timeslot, keep its day expanded so the choice stays visible.
    if (isSelecting) {
      const d = new Date(date);
      const key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
      setExpandedDays((prev) => ({ ...prev, [key]: true }));
    }
    setSelectedDates((prevDates) =>
      prevDates.includes(date)
        ? prevDates.filter((d) => d !== date)
        : [...prevDates, date]
    );
  };

  const handleConfirm = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    if (selectedDates.length === quantity) {
      // Sort the selected dates and get their corresponding names and IDs
      const selectedClassDates = selectedDates.map(date => {
        const classDate = classDates.find(cd => cd.date === date);
        return {
          date: date,
          name: classDate.name,
          id: classDate.id
        };
      }).sort((a, b) => new Date(a.date) - new Date(b.date));
      
      // Get the existing activeCourse cookie
      const activeCourse = JSON.parse(Cookies.get('activeCourse') || '{}');
      
      const computedPrice = pricingMode === 'fixed' ? baseFee : baseFee * quantity;

      const updatedCookie = {
        ...activeCourse,
        quantity,
        selectedDates: selectedClassDates,
        selectedClassIds: selectedClassDates.map(date => date.id),
        totalPrice: computedPrice
      };
      
      // Make sure selectedDates is also in the course object for compatibility
      if (updatedCookie.course) {
        updatedCookie.course.selectedDates = selectedClassDates;
        updatedCookie.course.selectedClassIds = selectedClassDates.map(date => date.id);
      }
      
      console.log("Setting updated cookie:", updatedCookie);
      Cookies.set('activeCourse', JSON.stringify(updatedCookie));

      onConfirm({ 
        quantity, 
        selectedDates: selectedClassDates,
        selectedClassIds: selectedClassDates.map(date => date.id),
        totalPrice: computedPrice
      });
    }
  };

  const totalPrice = pricingMode === 'fixed' ? baseFee : baseFee * quantity;

  // Resolve selected dates back to their class objects, sorted chronologically,
  // so we can show a running summary of everything the user has picked.
  const selectedClassList = selectedDates
    .map((date) => classDates.find((cd) => cd.date === date))
    .filter(Boolean)
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  // Only worth showing the summary bar when more than one date can be chosen.
  const showSummary = quantity > 1;

  const sortedFixedDates = [...fixedClassDates].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  const hasFixedDates = sortedFixedDates.length > 0;

  return (
    <Container onClick={(e) => e.stopPropagation()}>
      <Header>{isExact ? `Select ${maxQuantity} Date${maxQuantity > 1 ? 's' : ''}` : 'Select Quantity and Dates'}</Header>
      {!isExact && (
        <>
          <QuantityContainer>
            <span>Quantity:</span>
            <QuantityButton onClick={(e) => {
              e.stopPropagation();
              handleQuantityChange(-1);
            }}>-</QuantityButton>
            <span>{quantity}</span>
            <QuantityButton onClick={(e) => {
              e.stopPropagation();
              handleQuantityChange(1);
            }}>+</QuantityButton>
          </QuantityContainer>
          {quantity === maxQuantity && (
            <Notice>Max quantity has been reached</Notice>
          )}
        </>
      )}
      {showSummary && (
        <SummaryWrap>
          <SummaryHeader>
            <SummaryTitle>Selected dates</SummaryTitle>
            <SummaryProgress $complete={selectedDates.length === quantity}>
              {selectedDates.length} / {quantity}
            </SummaryProgress>
          </SummaryHeader>
          {selectedClassList.length === 0 ? (
            <EmptySummary>No dates selected yet</EmptySummary>
          ) : (
            <ChipRow>
              {selectedClassList.map((cd) => (
                <Chip key={cd.id}>
                  {new Date(cd.date).toLocaleDateString([], { day: '2-digit', month: 'short' })}, {new Date(cd.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  <ChipRemove
                    type="button"
                    aria-label="Remove date"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDateChange(cd.date);
                    }}
                  >
                    &#10005;
                  </ChipRemove>
                </Chip>
              ))}
            </ChipRow>
          )}
        </SummaryWrap>
      )}
      <DateList>
        {hasFixedDates && (
          <>
            <SectionLabel>Included dates</SectionLabel>
            {sortedFixedDates.map((classDate) => (
              <FixedDateItem key={classDate.id}>
                <FixedIcon>&#10003;</FixedIcon>
                <DateLabel>
                  {new Date(classDate.date).toLocaleDateString()} {new Date(classDate.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - {classDate.name}
                </DateLabel>
              </FixedDateItem>
            ))}
            <Divider />
            <SectionLabel>Select {maxQuantity} date{maxQuantity > 1 ? 's' : ''}</SectionLabel>
          </>
        )}
        {dayGroups.map((group) => {
          const isOpen = !!expandedDays[group.key];
          const selectedInDay = group.items.filter((cd) =>
            selectedDates.includes(cd.date)
          ).length;
          const availableCount = group.items.filter(
            (cd) => cd.availability !== 0
          ).length;
          const dayLabel = group.date.toLocaleDateString([], {
            weekday: 'short',
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          });
          return (
            <DayGroup key={group.key}>
              <DayHeader
                type="button"
                $open={isOpen}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDay(group.key);
                }}
              >
                <DayHeaderLeft>
                  {dayLabel}
                  {selectedInDay > 0 ? (
                    <SelectedPill>{selectedInDay} selected</SelectedPill>
                  ) : (
                    <DaySummary>
                      {group.items.length} time{group.items.length > 1 ? 's' : ''}
                      {availableCount === 0 ? ' · full' : ''}
                    </DaySummary>
                  )}
                </DayHeaderLeft>
                <Chevron $open={isOpen}>&#9660;</Chevron>
              </DayHeader>
              {isOpen && (
                <TimeslotList>
                  {group.items.map((classDate) => {
                    const isClassFull = classDate.availability === 0;
                    const isDisabled =
                      isClassFull ||
                      (!selectedDates.includes(classDate.date) &&
                        selectedDates.length >= quantity);
                    return (
                      <TimeslotItem
                        key={classDate.id}
                        $full={isClassFull}
                        $disabled={isDisabled}
                      >
                        <input
                          type="checkbox"
                          value={classDate.date}
                          checked={selectedDates.includes(classDate.date)}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleDateChange(classDate.date);
                          }}
                          disabled={isDisabled}
                        />
                        <DateLabel>
                          {new Date(classDate.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - {classDate.name}
                          {isClassFull && <FullBadge>FULL</FullBadge>}
                          {classDate.availability !== null && classDate.availability > 0 && (
                            <AvailabilityBadge>({classDate.availability} left)</AvailabilityBadge>
                          )}
                        </DateLabel>
                      </TimeslotItem>
                    );
                  })}
                </TimeslotList>
              )}
            </DayGroup>
          );
        })}
      </DateList>
      {selectedDates.length === 0 || selectedDates.length !== quantity ? (
        <Notice>Please select {quantity} date{quantity > 1 ? 's' : ''}</Notice>
      ) : null}
      <Footer>
        <PriceDisplay>HK$ {totalPrice}</PriceDisplay>
        {selectedDates.length === quantity ? (
          <ConfirmButton 
            onTouchEnd={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleConfirm();
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleConfirm();
            }}
          >
            Book Now
          </ConfirmButton>
        ) : (
          <ConfirmButton disabled>
            Select {quantity} date{quantity > 1 ? 's' : ''}
          </ConfirmButton>
        )}
      </Footer>
    </Container>
  );
};

export default QuantityDateSelector;